import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const AiIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.1145 2.79688L13.4872 6.50653L17.1969 7.87923L13.4872 9.25192L12.1145 12.9616L10.7418 9.25192L7.03217 7.87923L10.7418 6.50653L12.1145 2.79688Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5.76158 11.2675L6.9607 13.033L8.72629 14.2322L6.9607 15.4313L5.76158 17.1969L4.56246 15.4313L2.79688 14.2322L4.56246 13.033L5.76158 11.2675Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

AiIcon.displayName = 'AiIcon';
